/*
  Yake revizeleri (19 Eyl 2026)
  - Favoriler: tarayıcıda saklanan ürün listesi (localStorage), buton + liste bileşeni
  - Koleksiyon "Görünüm 1 / 2 / 3" seçici
  - Ürün sayfası "Kombini Gör" çekmecesi
  - Sepet / Favoriler sekmeleri
*/
(() => {
  if (window.YkRevize) return;

  const ANAHTAR = 'yk:favoriler';
  const GORUNUM_ANAHTAR = 'yk:gorunum-v2'; // 10 Eki: 1/3 anlamı ters çevrildi (1 = küçük, 3 = büyük); eski kayıt okunmaz
  const kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ayar = window.ykAyar || {};

  const oku = () => {
    try {
      const v = JSON.parse(localStorage.getItem(ANAHTAR) || '[]');
      return Array.isArray(v) ? v.filter((x) => typeof x === 'string') : [];
    } catch (e) {
      return [];
    }
  };
  const yaz = (liste) => {
    try {
      localStorage.setItem(ANAHTAR, JSON.stringify(liste));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('yk:favoriler', { detail: { liste } }));
  };

  const Favoriler = {
    liste: oku,
    var: (handle) => oku().includes(handle),
    degistir(handle) {
      const liste = oku();
      const i = liste.indexOf(handle);
      if (i > -1) liste.splice(i, 1);
      else liste.unshift(handle);
      yaz(liste);
      return i === -1;
    },
    cikar(handle) {
      yaz(oku().filter((h) => h !== handle));
    },
  };

  const para = (kurus) => {
    const tutar = (kurus / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const bicim = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || ayar.paraBicimi || '{{amount}} TL';
    return bicim.replace(/\{\{\s*\w+\s*\}\}/, tutar).replace(/<[^>]+>/g, '');
  };
  const kacis = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const gorselUrl = (src, w) => {
    if (!src) return '';
    const u = new URL(src, location.origin);
    u.searchParams.set('width', w);
    return u.toString();
  };

  const butonlariEsitle = (kapsam = document) => {
    const liste = oku();
    kapsam.querySelectorAll('[data-yk-fav]').forEach((b) => {
      const acik = liste.includes(b.dataset.ykFav);
      b.setAttribute('aria-pressed', acik ? 'true' : 'false');
      b.setAttribute('aria-label', acik ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
    document.querySelectorAll('[data-yk-fav-sayi]').forEach((e) => (e.textContent = liste.length));
  };

  document.addEventListener('click', (olay) => {
    const b = olay.target.closest('[data-yk-fav]');
    if (!b) return;
    olay.preventDefault();
    olay.stopPropagation();
    Favoriler.degistir(b.dataset.ykFav);
  });
  document.addEventListener('yk:favoriler', () => butonlariEsitle());

  // Filtre / sayfalama sonrası ızgara yeniden basıldığında butonları ve görünümü eşitle
  const gozlemci = new MutationObserver((kayitlar) => {
    for (const k of kayitlar) {
      for (const n of k.addedNodes) {
        if (n.nodeType === 1 && (n.matches('[data-yk-fav], [data-yk-izgara]') || n.querySelector('[data-yk-fav], [data-yk-izgara]'))) {
          butonlariEsitle();
          gorunumUygula();
          return;
        }
      }
    }
  });

  /* ---------- Favori listesi ---------- */
  const urunOnbellek = new Map();
  const urunGetir = (handle) => {
    if (!urunOnbellek.has(handle)) {
      urunOnbellek.set(
        handle,
        fetch(`${kok}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      );
    }
    return urunOnbellek.get(handle);
  };

  const urunKarti = (u, { cikarilabilir = false, rozet = '' } = {}) => {
    const fiyat = ayar.fiyatGoster === false ? '' : `<p class="yk-urun__fiyat">${para(u.price)}</p>`;
    const gorsel = u.featured_image
      ? `<img src="${gorselUrl(u.featured_image, 480)}" alt="${kacis(u.title)}" loading="lazy" width="480" height="640">`
      : '';
    return `<li class="yk-urun" data-handle="${kacis(u.handle)}">
      <a class="yk-urun__gorsel" href="${kacis(u.url)}">${gorsel}${rozet ? `<span class="yk-urun__rozet">${kacis(rozet)}</span>` : ''}</a>
      <div class="yk-urun__bilgi">
        <a class="yk-urun__baslik" href="${kacis(u.url)}">${kacis(u.title)}</a>
        ${fiyat}
      </div>
      ${cikarilabilir ? `<button type="button" class="yk-urun__cikar" data-yk-fav-cikar="${kacis(u.handle)}" aria-label="Favorilerden çıkar">&times;</button>` : ''}
    </li>`;
  };

  class YkFavoriListe extends HTMLElement {
    connectedCallback() {
      this._ciz = this.ciz.bind(this);
      document.addEventListener('yk:favoriler', this._ciz);
      this.addEventListener('click', (olay) => {
        const c = olay.target.closest('[data-yk-fav-cikar]');
        if (c) Favoriler.cikar(c.dataset.ykFavCikar);
      });
      this.ciz();
    }
    disconnectedCallback() {
      document.removeEventListener('yk:favoriler', this._ciz);
    }
    async ciz() {
      const liste = oku();
      if (!liste.length) {
        this.innerHTML = `<div class="yk-bos"><p class="yk-bos__baslik">Favori listeniz boş</p><p>Beğendiğiniz ürünlerdeki kalp simgesine dokunarak buraya ekleyebilirsiniz.</p></div>`;
        return;
      }
      const sira = ++this._sira || (this._sira = 1);
      const urunler = (await Promise.all(liste.map(urunGetir))).filter(Boolean);
      if (sira !== this._sira) return;
      this.innerHTML = `<ul class="yk-urunler yk-urunler--${this.dataset.duzen || 'izgara'}">${urunler
        .map((u) => urunKarti(u, { cikarilabilir: true }))
        .join('')}</ul>`;
    }
  }
  if (!customElements.get('yk-favori-liste')) customElements.define('yk-favori-liste', YkFavoriListe);

  /* ---------- Sekmeler (Sepet / Favoriler) ---------- */
  document.addEventListener('click', (olay) => {
    const s = olay.target.closest('[data-yk-sekme]');
    if (!s) return;
    const kapsam = s.closest('[data-yk-sekmeler]');
    if (!kapsam) return;
    olay.preventDefault();
    sekmeAc(kapsam, s.dataset.ykSekme);
  });
  const sekmeAc = (kapsam, ad) => {
    kapsam.dataset.ykAktif = ad;
    kapsam.querySelectorAll('[data-yk-sekme]').forEach((b) => b.setAttribute('aria-selected', b.dataset.ykSekme === ad ? 'true' : 'false'));
  };

  /* ---------- Koleksiyon görünümü ---------- */
  const gorunumOku = () => {
    try {
      const v = localStorage.getItem(GORUNUM_ANAHTAR);
      return ['1', '2', '3'].includes(v) ? v : null;
    } catch (e) {
      return null;
    }
  };
  function gorunumUygula(deger) {
    const v = deger || gorunumOku() || '2';
    document.querySelectorAll('[data-yk-izgara]:not([data-yk-sabit])').forEach((g) => {
      if (g.dataset.ykGorunum !== v) g.dataset.ykGorunum = v;
      gorselBoyutu(g, v);
    });
    document.querySelectorAll('[data-yk-gorunum-sec]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.ykGorunumSec === v ? 'true' : 'false'));
  }
  // Seçilen sütun sayısına göre <img sizes> güncellenir; büyük görünümde bulanık, küçükte gereksiz büyük görsel inmesin
  const SUTUN = { 1: [3, 4, 6], 2: [2, 3, 4], 3: [1, 2, 3] };
  function gorselBoyutu(g, v) {
    const s = SUTUN[v];
    if (!s) return;
    const deger = `(max-width: 767px) calc(100vw / ${s[0]}), (max-width: 1279px) calc(100vw / ${s[1]}), calc(100vw / ${s[2]})`;
    g.querySelectorAll('.product-card img[srcset]').forEach((img) => {
      if (img.getAttribute('sizes') !== deger) img.setAttribute('sizes', deger);
    });
  }
  document.addEventListener('click', (olay) => {
    const b = olay.target.closest('[data-yk-gorunum-sec]');
    if (!b) return;
    olay.preventDefault();
    try {
      localStorage.setItem(GORUNUM_ANAHTAR, b.dataset.ykGorunumSec);
    } catch (e) {}
    gorunumUygula(b.dataset.ykGorunumSec);
    window.dispatchEvent(new Event('resize'));
  });

  /* ---------- Kombini Gör ---------- */
  class YkKombin extends HTMLElement {
    connectedCallback() {
      // Üst öğelerdeki transform, fixed konumu bozmasın diye çekmeceyi body'ye taşı
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
        return;
      }
      if (this._hazir) return;
      this._hazir = true;
      this.tetik = document.querySelector('[data-yk-kombin-ac]');
      this.govde = this.querySelector('[data-yk-kombin-govde]');
      this.hazirla();
      this.addEventListener('click', (olay) => {
        if (olay.target.closest('[data-yk-kombin-kapat]')) this.kapat();
      });
      document.addEventListener('keydown', (olay) => {
        if (olay.key === 'Escape' && this.hasAttribute('open')) this.kapat();
      });
      document.addEventListener('click', (olay) => {
        if (olay.target.closest('[data-yk-kombin-ac]')) {
          olay.preventDefault();
          this.ac();
        }
      });
    }
    async hazirla() {
      let urunler = [];
      const handlelar = (this.dataset.handlelar || '').split(',').map((h) => h.trim()).filter(Boolean);
      if (handlelar.length) {
        urunler = (await Promise.all(handlelar.map(urunGetir))).filter(Boolean);
      } else if (this.dataset.urunId) {
        try {
          const r = await fetch(`${kok}recommendations/products.json?product_id=${this.dataset.urunId}&intent=complementary&limit=8`);
          const j = r.ok ? await r.json() : { products: [] };
          urunler = j.products || [];
        } catch (e) {}
      }
      if (!urunler.length) return;
      // 22 Eki (Excel 173): her kombin ürününe varyant seçimi + "Tüm Kombini Satın Al"
      const secim = (u) => {
        const vars = (u.variants || []).filter((v) => v.available);
        if (!vars.length) return `<p class="yk-kombin__tukendi">Tükendi</p>`;
        if (vars.length === 1) return `<input type="hidden" data-yk-kombin-varyant value="${vars[0].id}">`;
        return `<select class="yk-kombin__secim" data-yk-kombin-varyant aria-label="${kacis(u.title)} seçenek">${vars.map((v) => `<option value="${v.id}">${kacis(v.title)}</option>`).join('')}</select>`;
      };
      this.govde.innerHTML = `<ul class="yk-urunler yk-urunler--izgara">${urunler.map((u) => urunKarti(u).replace('</li>', `<div class="yk-kombin__urun-secim">${secim(u)}</div></li>`)).join('')}</ul>
        <div class="yk-kombin__alt"><button type="button" class="yk-kombin__hepsi" data-yk-kombin-hepsi>Tüm Kombini Satın Al</button><p class="yk-kombin__mesaj" data-yk-kombin-mesaj role="status"></p></div>`;
      this.govde.querySelector('[data-yk-kombin-hepsi]').addEventListener('click', () => this.hepsiniEkle());
      document.querySelectorAll('[data-yk-kombin-ac]').forEach((t) => t.removeAttribute('hidden'));
    }
    async hepsiniEkle() {
      const dugme = this.govde.querySelector('[data-yk-kombin-hepsi]');
      const mesaj = this.govde.querySelector('[data-yk-kombin-mesaj]');
      const items = [];
      // sayfadaki ürün: formda seçili varyant
      const anaForm = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (anaForm && anaForm.value) items.push({ id: Number(anaForm.value), quantity: 1 });
      this.govde.querySelectorAll('[data-yk-kombin-varyant]').forEach((s) => { if (s.value) items.push({ id: Number(s.value), quantity: 1 }); });
      if (!items.length) { mesaj.textContent = 'Sepete eklenecek ürün bulunamadı.'; return; }
      dugme.disabled = true; dugme.textContent = 'Ekleniyor…'; mesaj.textContent = '';
      try {
        const r = await fetch(`${kok}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const j = await r.json();
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Eklenemedi');
        window.location.href = `${kok}cart`;
      } catch (e) {
        mesaj.textContent = e.message || 'Eklenemedi, lütfen tekrar deneyin.';
        dugme.disabled = false; dugme.textContent = 'Tüm Kombini Satın Al';
      }
    }
    ac() {
      this.removeAttribute('hidden');
      requestAnimationFrame(() => this.setAttribute('open', ''));
      document.documentElement.classList.add('yk-kilit');
    }
    kapat() {
      this.removeAttribute('open');
      document.documentElement.classList.remove('yk-kilit');
      setTimeout(() => this.setAttribute('hidden', ''), 300);
    }
  }
  if (!customElements.get('yk-kombin')) customElements.define('yk-kombin', YkKombin);

  const basla = () => {
    butonlariEsitle();
    gorunumUygula();
    gozlemci.observe(document.body, { childList: true, subtree: true });
    const p = new URLSearchParams(location.search);
    if (p.get('sekme') === 'favoriler' || location.hash === '#favoriler') {
      document.querySelectorAll('[data-yk-sekmeler][data-yk-url-sekme]').forEach((k) => sekmeAc(k, 'favoriler'));
    }
  };
  // Tembel yüklenen kart görsellerinin sizes değeri sayfa yüklenince tekrar eşitlenir
  window.addEventListener('load', () => gorunumUygula());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla);
  else basla();

  window.YkRevize = { Favoriler, gorunumUygula, sekmeAc };
})();
